export default "__VITE_ASSET__8g3dFpkA__"